var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('material-dialog',{ref:"tpl_edit",attrs:{"formTitle":"删除模板"},on:{"handleSave":_vm.handleDel}},[_c('template',{slot:"content"},[_vm._v(" "+_vm._s(_vm.title)+" ")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }